<template>
  <section class="page bg" v-lazy:background-image="'/static/img/cooperate/1-bg2.png'">
    <article class="container">
      <wl-title title='联系我们' :isNeedDesc=false></wl-title>
      <section class="flexWrap">
        <section v-for="(item,idx) in pageData" :key="item.key" class="flex">
          <section class="_icon " :style="`background-position: -${5+81*idx}px -104px;`"></section>
          <section>
            <h3>{{item.title}}</h3>
            <p>{{item.desc}}</p>
          </section>
        </section>
      </section>
    </article>
  </section>
</template>

<script>
export default {
  name: 'cocontactPage',
  data() {
    return {
      pageData: [
        { title: '联系人', desc: '李先生', key: 'cooperate-ren' },
        { title: '电话', desc: '18922397795', key: 'cooperate-tel' },
        { title: '邮箱', desc: 'yewu@weileit.com', key: 'cooperate-em' }
      ],
    }
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
._icon {
  background: url("/static/img/cooperate/icon-sprite2.png");
}
p {
  color: #8e8e8e;
}
h3 {
  color: #262626;
  line-height: 28px;
  font-size: 28px;
  font-weight: 500;
}
.page {
  height: 463px;
  padding-top: 136px;
  ._icon {
    width: 81px;
    height: 86px;
  }
  .flexWrap {
    padding-top: 74px;
    .flex {
      text-align: left;
      align-items: center;
      section {
        margin-left: 8px;
      }
      h3 {
        line-height: 36px;
      }
      p {
        font-size: 24px;
        line-height: 36px;
      }
    }
  }
}
</style>
